import { render } from "./A2HsView.vue?vue&type=template&id=658c05fa"
import script from "./A2HsView.vue?vue&type=script&lang=js"
export * from "./A2HsView.vue?vue&type=script&lang=js"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__